import { Catalogue } from '@app/models/Catalogue/Catalogue.interface';
import {
  Category,
  CategoriesObject,
} from '@models/Category/Category.interface';
import { Service } from '@models/Service/Service.interface';
import { ServiceGroup } from '@models/ServiceGroup/ServiceGroup.interface';

export interface CatalogueState {
  id: number;
  type: 'biznes' | 'uslugi';
  servicesCount: number;
  rootCategories: number[];
  levels: number[];
  paths: string[];
  categories: CategoriesObject;
  categoriesByPath: CategoriesObject;
  services: Service[];
  groups: ServiceGroup[];
  lastOpenedCategory: Category | null;
  expandedElements: number[];
  isLoading: boolean;
  isBlocked: boolean;
  isPopular: boolean;
  animationDisabled: boolean;
  fromRoute: string;
}

export const UPDATE_CATALOGUE = 'UPDATE_CATALOGUE';
export const ADD_CATEGORY = 'ADD_CATEGORY';
export const CLEAR_CATEGORIES = 'CLEAR_CATEGORIES';
export const ADD_SERVICE = 'ADD_SERVICE';
export const CLEAR_SERVICES = 'CLEAR_SERVICES';
export const ADD_GROUP = 'ADD_GROUP';
export const CLEAR_GROUPS = 'CLEAR_GROUPS';
export const ADD_LEVEL = 'ADD_LEVEL';
export const UPDATE_LEVELS = 'UPDATE_LEVELS';
export const ADD_PATH = 'ADD_PATH';
export const UPDATE_PATHS = 'UPDATE_PATHS';
export const CLEAR_LEVELS = 'CLEAR_LEVELS';
export const SET_LAST_OPENED_CATEGORY = 'SET_LAST_OPENED_CATEGORY';
export const START_LOADING = 'START_LOADING';
export const END_LOADING = 'END_LOADING';
export const SET_BLOCKED = 'SET_BLOCKED';
export const SET_ANIMATION_DISABLED = 'SET_ANIMATION_DISABLED';
export const ADD_EXPANDED_ELEMENT = 'ADD_EXPANDED_ELEMENT';
export const CLEAR_EXPANDED_ELEMENTS = 'CLEAR_EXPANDED_ELEMENTS';
export const INIT_IS_POPULAR = 'INIT_IS_POPULAR';
export const SET_IS_POPULAR = 'SET_IS_POPULAR';
export const SET_FROM_ROUTE = 'SET_FROM_ROUTE';

interface SetAnimationDisabledAction {
  type: typeof SET_ANIMATION_DISABLED;
  value: boolean;
}

interface SetBlockedAction {
  type: typeof SET_BLOCKED;
  value: boolean;
}

interface StartLoadingAction {
  type: typeof START_LOADING;
}

interface EndLoadingAction {
  type: typeof END_LOADING;
}

interface UpdateCatalogueAction {
  type: typeof UPDATE_CATALOGUE;
  payload: Catalogue;
}

interface AddCategoryAction {
  type: typeof ADD_CATEGORY;
  category: Category;
}

interface ClearCategoriesAction {
  type: typeof CLEAR_CATEGORIES;
  lockedCategories: number[];
}

interface AddServiceAction {
  type: typeof ADD_SERVICE;
  service: Service;
}

interface AddGroupAction {
  type: typeof ADD_GROUP;
  group: ServiceGroup;
}

interface AddLevelAction {
  type: typeof ADD_LEVEL;
  categoryId: number;
}

interface UpdateLevelsAction {
  type: typeof UPDATE_LEVELS;
  levels: number[];
}

interface AddPathAction {
  type: typeof ADD_PATH;
  path: string;
}

interface UpdatePathsAction {
  type: typeof UPDATE_PATHS;
  paths: string[];
}

interface ClearServicesAction {
  type: typeof CLEAR_SERVICES;
}

interface ClearGroupsAction {
  type: typeof CLEAR_GROUPS;
}

interface ClearLevelsAction {
  type: typeof CLEAR_LEVELS;
}

interface SetLastOpenedCategoryAction {
  type: typeof SET_LAST_OPENED_CATEGORY;
  lastOpenedCategory: Category;
}

interface ClearExpandedElementsAction {
  type: typeof CLEAR_EXPANDED_ELEMENTS;
}

interface AddExpandedElementAction {
  type: typeof ADD_EXPANDED_ELEMENT;
  elementId: number;
}

interface InitIsPopular {
  type: typeof INIT_IS_POPULAR;
  isPopular: boolean;
}

interface SetIsPopular {
  type: typeof SET_IS_POPULAR;
  isPopular: boolean;
}

interface SetFromRouteAction {
  type: typeof SET_FROM_ROUTE;
  value: string;
}

export type CatalogueActionTypes =
  | AddExpandedElementAction
  | ClearExpandedElementsAction
  | SetAnimationDisabledAction
  | SetBlockedAction
  | AddGroupAction
  | ClearGroupsAction
  | StartLoadingAction
  | EndLoadingAction
  | UpdateCatalogueAction
  | AddCategoryAction
  | ClearCategoriesAction
  | AddServiceAction
  | ClearServicesAction
  | AddLevelAction
  | ClearLevelsAction
  | UpdateLevelsAction
  | SetLastOpenedCategoryAction
  | AddPathAction
  | UpdatePathsAction
  | SetIsPopular
  | InitIsPopular
  | SetFromRouteAction;
